// Central content + helpers for ALCH website

export const CLINIC = {
  name: "Advanced Laser Care Hospital",
  short: "ALCH",
  tagline: "Kumaon's Most Advanced Laser Surgery Centre",
  phone: "+91 84484 44171",
  phoneRaw: "918448444171",
  email: "info@alchospital.com",
  whatsapp: "918448444171",
  hours: "",
  address: "Canal Rd, near Hydel Mandir, Kathgodam, Haldwani, Uttarakhand 263126",
  facebook: "https://facebook.com/ALCHOSPITAL",
  instagram: "https://instagram.com/advancedlasercarehospital",
  since: "2019",
};

export const waLink = (message) =>
  `https://wa.me/${CLINIC.whatsapp}?text=${encodeURIComponent(message || `Hello ${CLINIC.short}, I would like to book an appointment.`)}`;

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Treatments", to: "/treatments" },
  { label: "Doctor", to: "/doctor" },
  { label: "Blog", to: "/blog" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

export const STATS = [
  { value: 10, suffix: "+", label: "Expert Doctors" },
  { value: 5000, suffix: "+", label: "Happy Patients" },
  { value: 20, suffix: "+", label: "Treatments Offered" },
  { value: 100, suffix: "%", label: "Minimally Invasive" },
];

export const MARQUEE = [
  "Laser Piles", "Varicose Veins EVLT", "Laparoscopic Surgery",
  "Fistula FiLaC", "Cosmetic Gynaecology", "Laser Fissure",
  "Pilonidal Sinus", "Day Care Procedures",
];

export const FEATURES = [
  { no: "01", title: "Pioneer Laser Centre in Kumaon", text: "Among the very first to introduce advanced laser treatments in the region." },
  { no: "02", title: "Affordable & Transparent Pricing", text: "World-class laser surgery at the most reasonable cost in all of Kumaon." },
  { no: "03", title: "Patient-First Philosophy", text: "Ethical care, clear guidance, and strong post-treatment support throughout." },
  { no: "04", title: "Modern Facility", text: "State-of-the-art laser and laparoscopic infrastructure with the highest safety protocols." },
];

export const SERVICES = [
  {
    key: "physician",
    title: "General Physician Services",
    items: ["Cold, Cough & Bronchitis", "Viral Fever, Typhoid, Dengue, Malaria", "Diabetes Management", "Blood Pressure Management", "Thyroid Disorders"],
    image: "https://images.unsplash.com/photo-1758691463198-dc663b8a64e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxzbWlsaW5nJTIwcGF0aWVudCUyMGRvY3RvciUyMGNvbnN1bHRhdGlvbnxlbnwwfHx8fDE3ODU4NTQyMTF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "gynaecology",
    title: "Laser Cosmetic Gynaecology",
    items: ["Laser Vaginal Rejuvenation (LVR)", "Stress Urinary Incontinence", "Vaginal Tightening Procedures", "Vaginal Dryness Treatment", "Dyspareunia Management"],
    image: "https://images.pexels.com/photos/33812025/pexels-photo-33812025.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    key: "laparoscopic",
    title: "Advanced Laparoscopic Surgery",
    items: ["Gall Bladder Stone Surgery", "Hernia Surgery", "Appendix Surgery", "Uterus Fibroid Surgery", "Ovarian Cyst Surgery"],
    image: "https://images.unsplash.com/photo-1550831107-1553da8c8464?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxsYXNlciUyMHN1cmdlcnklMjBtZWRpY2FsfGVufDB8fHx8MTc4NTg1NDIxMXww&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "vascular",
    title: "Laser Vascular & Proctology",
    items: ["Laser Treatment for Varicose Veins (EVLT)", "Laser Piles Treatment", "Laser Fissure Treatment", "Laser Fistula (PILTEC / FiLaC)", "Laser Pilonidal Sinus Treatment"],
    image: "https://images.unsplash.com/photo-1700760934166-4c766d708139?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwbGFzZXIlMjBtYWNoaW5lfGVufDB8fHx8MTc4MTk0OTg5OXww&ixlib=rb-4.1.0&q=85",
  },
];

export const WHY = [
  { title: "Advanced Technology", text: "State-of-the-art laser and laparoscopic systems for unmatched precision, safety, and outcomes." },
  { title: "Minimally Invasive Care", text: "Less pain, minimal incisions, faster recovery, and early discharge." },
  { title: "Expert Surgical Leadership", text: "All procedures performed or supervised by Dr. Pramod Kumar Karan." },
  { title: "Most Affordable in Kumaon", text: "World-class laser treatments at the most reasonable cost in the region." },
  { title: "Patient-Centric Approach", text: "Ethical care, clear communication, strong post-treatment support." },
  { title: "Trusted Reputation", text: "Thousands of successful procedures and consistently positive patient outcomes across the region." },
];

export const MISSION = [
  { no: "01", title: "Safety First", text: "Every procedure follows the strictest safety protocols with advanced sterilization and monitoring." },
  { no: "02", title: "Precision Treatment", text: "Laser technology enables pinpoint accuracy, minimizing damage to surrounding healthy tissue." },
  { no: "03", title: "Accessible to All", text: "High-quality surgical care should not be a privilege — it is a right for every patient." },
  { no: "04", title: "Faster Recovery", text: "Minimally invasive techniques mean less downtime, less scarring, quicker return to normal life." },
];

export const DOCTOR = {
  name: "Dr. Pramod Kumar Karan",
  role: "MS Surgery · Laser Specialist · Chief Laser & Laparoscopic Surgeon",
  image: "https://images.unsplash.com/photo-1612531385446-f7e6d131e1d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxkb2N0b3IlMjB3YXJtJTIwbGlnaHRpbmclMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODU4NTQyMTF8MA&ixlib=rb-4.1.0&q=85",
  bio: "Dr. Pramod Kumar Karan (Dr. Karan) is a renowned and highly experienced surgeon who founded and leads Advanced Laser Care Hospital in Haldwani. With deep expertise in laser and laparoscopic procedures, he is a trusted and respected name in surgical care across the entire Kumaon region. Under his leadership since 2019, ALCH has become the most advanced laser treatment centre in the area, delivering thousands of successful procedures with excellent outcomes.",
  quote: "Our goal is not just to treat disease, but to restore confidence, comfort, and quality of life for every patient who walks through our doors.",
  expertise: ["Laser Piles", "Varicose Veins EVLT", "Fistula FiLaC", "Laser Fissure", "Pilonidal Sinus", "Laparoscopic Surgery", "Hernia Repair", "Gallbladder Surgery", "Cosmetic Gynaecology", "Ovarian Cyst"],
  stats: [
    { value: "5+", label: "Years Experience" },
    { value: "5K+", label: "Procedures" },
    { value: "20+", label: "Treatments" },
  ],
};

export const AWARDS = [
  { title: "Best Laser Surgery Centre — Kumaon", text: "Recognized as the region's most advanced and trusted laser surgery centre for minimally invasive care." },
  { title: "Healthcare Excellence Award", text: "Awarded for outstanding contribution to affordable, accessible quality healthcare in Uttarakhand." },
  { title: "Patient Choice Award", text: "Voted most trusted hospital for piles, fissure, and varicose vein treatment by patients in Haldwani." },
  { title: "Innovation in Surgery", text: "Recognized for pioneering advanced laser and laparoscopic day-care techniques in Kumaon." },
];

export const TESTIMONIALS = [
  { name: "Amit Kumar", place: "Haldwani", stars: 4, text: "Visited for fissure treatment. The laser procedure was quick, almost painless and recovery was just 2 days. Dr. Karan explained everything clearly. Excellent!" },
  { name: "Vijay R.", place: "Bhimtal, Uttarakhand", stars: 4, text: "Dr. Karan is very humble, knowledgeable and caring. Hernia surgery done laparoscopically and I recovered in 3 days. Clean hospital, great equipment. Highly recommend!" },
  { name: "Anil K.", place: "Rudrapur, Uttarakhand", stars: 4, text: "Very professional team. My gallbladder laparoscopic surgery went smoothly. Cost was very reasonable compared to other hospitals in the region." },
  { name: "Priya M.", place: "Nainital, Uttarakhand", stars: 4, text: "I suffered from varicose veins for years. After EVLT laser treatment at ALCH, no pain and no scar. The whole procedure took just 1 hour. Amazing!" },
  { name: "Ramesh S.", place: "Haldwani, Uttarakhand", stars: 4, text: "Dr. Karan is an exceptional surgeon. My laser piles treatment was completely painless — I was home the same evening. ALCH is truly the best in Haldwani!" },
  { name: "Kailash Joshi", place: "Haldwani, Uttarakhand", stars: 4, text: "Visited for fissure treatment. The laser procedure was quick, almost painless and recovery was just 2 days. Dr. Karan explained everything clearly. Excellent!" },
];

export const GALLERY = [
  { url: "https://images.unsplash.com/photo-1758691463198-dc663b8a64e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxzbWlsaW5nJTIwcGF0aWVudCUyMGRvY3RvciUyMGNvbnN1bHRhdGlvbnxlbnwwfHx8fDE3ODU4NTQyMTF8MA&ixlib=rb-4.1.0&q=85", cap: "Patient Consultation" },
  { url: "https://images.unsplash.com/photo-1550831107-1553da8c8464?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxsYXNlciUyMHN1cmdlcnklMjBtZWRpY2FsfGVufDB8fHx8MTc4NTg1NDIxMXww&ixlib=rb-4.1.0&q=85", cap: "Surgical Team" },
  { url: "https://images.pexels.com/photos/33812025/pexels-photo-33812025.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", cap: "Modern Facility" },
  { url: "https://images.unsplash.com/photo-1700760934166-4c766d708139?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwbGFzZXIlMjBtYWNoaW5lfGVufDB8fHx8MTc4MTk0OTg5OXww&ixlib=rb-4.1.0&q=85", cap: "Advanced Laser System" },
  { url: "https://images.unsplash.com/photo-1612531385446-f7e6d131e1d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxkb2N0b3IlMjB3YXJtJTIwbGlnaHRpbmclMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODU4NTQyMTF8MA&ixlib=rb-4.1.0&q=85", cap: "Dr. Pramod Kumar Karan" },
  { url: "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?crop=entropy&cs=srgb&fm=jpg&q=85&w=940", cap: "Operating Theatre" },
];

export const BLOGS = [
  {
    slug: "laser-piles-treatment-painless",
    title: "Laser Piles Treatment: Why It's Virtually Painless",
    excerpt: "Traditional piles surgery meant weeks of discomfort. Laser treatment changes everything — here's how the day-care procedure works and why patients walk home the same evening.",
    date: "Nov 12, 2025",
    read: "5 min read",
    tag: "Proctology",
    image: "https://images.unsplash.com/photo-1700760934166-4c766d708139?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwbGFzZXIlMjBtYWNoaW5lfGVufDB8fHx8MTc4MTk0OTg5OXww&ixlib=rb-4.1.0&q=85",
    body: [
      "Piles (haemorrhoids) affect a huge number of adults, yet fear of painful surgery keeps many from seeking treatment. Laser haemorrhoidoplasty has transformed this experience completely.",
      "During the procedure, a fine laser fibre delivers precise energy that shrinks the haemorrhoidal tissue from the inside. There are no cuts, no stitches, and minimal bleeding. Most patients are discharged the same day and return to work within 24–48 hours.",
      "Because the surrounding healthy tissue is preserved, post-operative pain is dramatically reduced compared to conventional open surgery. At ALCH, Dr. Karan performs this as a routine day-care procedure with excellent outcomes.",
      "If you have been postponing treatment, a simple consultation can help you understand your grade of piles and the best path forward.",
    ],
  },
  {
    slug: "varicose-veins-evlt-guide",
    title: "Varicose Veins & EVLT: A Complete Patient Guide",
    excerpt: "Aching, heavy legs and visible veins are more than cosmetic. Endovenous Laser Therapy (EVLT) offers a scar-free, walk-in walk-out solution.",
    date: "Oct 28, 2025",
    read: "6 min read",
    tag: "Vascular",
    image: "https://images.unsplash.com/photo-1550831107-1553da8c8464?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxsYXNlciUyMHN1cmdlcnklMjBtZWRpY2FsfGVufDB8fHx8MTc4NTg1NDIxMXww&ixlib=rb-4.1.0&q=85",
    body: [
      "Varicose veins develop when the valves inside leg veins weaken, causing blood to pool. Left untreated they can lead to swelling, skin changes and ulcers.",
      "EVLT (Endovenous Laser Therapy) uses laser energy delivered through a thin catheter to seal the faulty vein. Blood is naturally rerouted to healthy veins. The entire procedure takes about an hour under local anaesthesia.",
      "There are no large incisions and no scars — just a tiny needle entry point. Patients walk immediately after and resume normal activity quickly.",
      "Early treatment gives the best cosmetic and health results, so don't ignore persistent leg heaviness or visible veins.",
    ],
  },
  {
    slug: "laparoscopic-gallbladder-surgery",
    title: "Laparoscopic Gallbladder Surgery: Faster Recovery",
    excerpt: "Gallstones causing pain? Keyhole surgery removes the gallbladder through tiny incisions with recovery measured in days, not weeks.",
    date: "Oct 09, 2025",
    read: "4 min read",
    tag: "Laparoscopy",
    image: "https://images.pexels.com/photos/33812025/pexels-photo-33812025.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: [
      "Gallstones are common and can cause severe pain, nausea and infection. When symptoms recur, removing the gallbladder (cholecystectomy) is the definitive treatment.",
      "Laparoscopic (keyhole) surgery uses a few small incisions and a camera to remove the gallbladder precisely. Compared to open surgery, it means less pain, smaller scars and a much faster recovery.",
      "Most patients go home within a day and resume daily life within a week. At ALCH the procedure is performed with modern laparoscopic systems for maximum safety.",
    ],
  },
];

export const blogBySlug = (slug) => BLOGS.find((b) => b.slug === slug);
